export const passDiscountReducer = (
	state = { loading: false, passes: null, error: null },
	action
) => {
	switch (action.type) {
		case 'PASS_DISCOUNT_LOADING':
			return {
				...state,
				loading: true,
				error: null
			}
		case 'PASS_DISCOUNT_SEARCH_SUCCESS':
			return {
				...state,
				loading: false,
				passes: action.payload?.passes || [],
				error: null
			}
		case 'PASS_DISCOUNT_ERROR':
			return {
				...state,
				loading: false,
				passes: [],
				error: action.payload || 'Error al buscar abonos'
			}
		case 'PASS_DISCOUNT_RESET':
			return {
				...state,
				loading: false,
				passes: null,
				error: null
			}
		default:
			return state
	}
}

export default passDiscountReducer

